<template lang="pug">
div
  h4.mr-3 Configuración de Jumpseller
  p Al conectar tu tienda de Jumpseller, los pedidos pagados se transformarán automáticamente en envíos dentro de la plataforma, los pedidos cancelados cancelarán su envío y el estado de cada envío se sincronizará de vuelta a Jumpseller.
  div(v-if="loading")
    b-spinner(small)
  div(v-else-if="integration && integration.connected")
    p
      | Tienda conectada:
      b.ml-1 {{ integration.storeUrl || integration.storeCode }}
    b-form-checkbox(
      switch
      :checked="integration.enabled"
      :disabled="saving"
      @change="toggleIntegration"
    ) {{ integration.enabled ? 'Sincronización activa' : 'Sincronización pausada' }}
    b-button.mt-3(variant="outline-primary" :disabled="connecting" @click="connectJumpseller") Volver a conectar
  div(v-else)
    b-button(variant="primary" :disabled="connecting || !storeId" @click="connectJumpseller") Conectar con Jumpseller
    p.mt-2.text-muted Serás redirigido a Jumpseller para autorizar el acceso de tu tienda.
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      connecting: false,
      saving: false,
      integration: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    storeId() {
      return this.user.role === 'store' ? this.user.storeId : null
    }
  },
  mounted() {
    this.fetchIntegration()
  },
  methods: {
    ...mapActions(['getJumpsellerAuthorizeUrl', 'getJumpsellerIntegration', 'setJumpsellerIntegration']),
    showError(message) {
      this.$bvToast.toast(message, { title: 'Error', variant: 'danger' })
    },
    async fetchIntegration() {
      if (!this.storeId) return
      this.loading = true
      try {
        const response = await this.getJumpsellerIntegration(this.storeId)
        this.integration = response.data.integration
      } catch (error) {
        this.showError('No se pudo obtener el estado de la integración con Jumpseller')
      } finally {
        this.loading = false
      }
    },
    async connectJumpseller() {
      if (!this.storeId) {
        this.showError('No se pudo determinar la tienda')
        return
      }
      this.connecting = true
      try {
        const response = await this.getJumpsellerAuthorizeUrl(this.storeId)
        window.location.href = response.data.url
      } catch (error) {
        this.connecting = false
        this.showError((error.response && error.response.data && error.response.data.error) || 'No se pudo iniciar la conexión con Jumpseller')
      }
    },
    async toggleIntegration(enabled) {
      this.saving = true
      try {
        const response = await this.setJumpsellerIntegration({ storeId: this.storeId, enabled })
        this.integration = response.data.integration
      } catch (error) {
        this.showError('No se pudo actualizar la integración con Jumpseller')
        await this.fetchIntegration()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
